import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import storage from '@/utils/storage'
import getPageTitle from '@/utils/get-page-title'
import { initPermissions, clearPermissions } from '@/utils/role-permission'
import { getProfileAPI } from '@/api/personal-center'



/* 无需权限即可访问的URL  */
const noPermissionsPathList = [
    '/sign-in',
    '/send-email',
    '/forgot-password',
    '/create-account',
    '/payment/balance',
    '/payment/balance/',
    '/payment/balance-wordpress/',
    '/payment/balance-wordpress',
    '/payment',
    '/payment/'
]

/* 过滤无权限URL  */
const handleFilterPath = targetPath => {

    return noPermissionsPathList.every(item => targetPath !== item)
}

NProgress.configure({ showSpinner: false })

router.beforeEach(async(to, from, next) => {
    NProgress.start()

    document.title = getPageTitle(to.meta.title)

    const { token, site_status } = storage.getItem('userInfo') || {}

    const hash = window.location.hash
    const urlParams = new URLSearchParams(hash.split('?')[1])
    const urlToken = urlParams.get('token')
    const urlJump = urlParams.get('jump')

    // 如果目标路径不需要权限，则直接通过
    console.log("to:",to.path)
    if (!handleFilterPath(to.path)) {
        NProgress.done()
        //return token ? next({ path: '/' }) : next()
        return next()
    }

    // 如果没有 Token或者urlToken 且需要登录，跳转到登录页面
    if (!token && handleFilterPath(to.path) && !urlToken) {

        NProgress.done()

        return next(`/sign-in`)

    }

    // 获取用户权限数据
    try {
        const res = await getProfileAPI()
        if (res && res.code === 1 && res.data && res.data.user_rules) {
            // 初始化权限数据

            initPermissions(res.data.user_rules)

        } else {
            clearPermissions()
        }
    } catch (error) {
        console.error('获取权限数据失败:', error)
        clearPermissions()
    }

    // 如果站点状态是 1 且路径是 /overview 或 /website 下的其他路由，跳转到 add-site 页面
    // if (site_status === 1 || site_status === 4) {
    //     if (
    //         to.path.includes('/overview') ||
    //         // to.path.includes('/subscribe') ||
    //         (to.path.includes('/website') && !to.path.includes('/website/add-site'))
    //     ) {
    //         NProgress.done()
    //         return next(`/website/add-site`)
    //     }
    // }

    // 正常流程
    NProgress.done()
    return next()
})

router.afterEach(() => {
    NProgress.done()
})